/**
 * Rascunho do wizard de onboarding (step + form) — retomar no Perfil.
 */

export const WIZARD_DRAFT_VERSION = 1;

const key = (userId) => `iron_wizard_draft_v${WIZARD_DRAFT_VERSION}_${String(userId)}`;

export function readWizardDraft(userId) {
  if (!userId || typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    if ((parsed.draftVersion || 0) < WIZARD_DRAFT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeWizardDraft(userId, draft) {
  if (!userId || typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(
      key(userId),
      JSON.stringify({
        ...draft,
        draftVersion: WIZARD_DRAFT_VERSION,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    /* quota */
  }
}

export function clearWizardDraft(userId) {
  if (!userId || typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(key(userId));
  } catch {
    /* ok */
  }
}

/** Step anterior a review (configuração incompleta). */
export function isWizardDraftResumable(draft) {
  if (!draft?.currentStep) return false;
  return draft.currentStep !== 'review' && draft.currentStep !== 'pipeline';
}
